export default __webpack_public_path__ + "static/media/DispatchBaggage.354c1e2b.svg";